import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ServicioContenidoModyo } from '@core/services/modyo/modyo-contenido.service';
import type { IconoEntry } from '@core/interfaces/modyo';
import { catchError, map, of, type Observable } from 'rxjs';

const SLUG_FAVICON = 'iconobmm';
const TIPO_CONTENIDO_ICONO = 'icono';

@Injectable({ providedIn: 'root' })
export class ServicioFavicon {
  private readonly documento = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly esNavegador = isPlatformBrowser(this.platformId);
  private readonly contenidoModyo = inject(ServicioContenidoModyo);

  public cargarFaviconDesdeCMS(): Observable<boolean> {
    if (!this.esNavegador) {
      return of(false);
    }

    return this.contenidoModyo.obtenerEntradaPorSlug<IconoEntry>(TIPO_CONTENIDO_ICONO, SLUG_FAVICON).pipe(
      map((entry) => {
        const url = entry?.fields?.imagen?.url;
        if (!url) return false;

        const contentType = entry.fields.imagen?.content_type || 'image/x-icon';
        this.actualizarFavicon(url, contentType);
        return true;
      }),
      catchError(() => of(false)),
    );
  }

  private actualizarFavicon(url: string, type: string): void {
    const linkExistente = this.documento.querySelector<HTMLLinkElement>("link[rel='icon']");

    if (linkExistente) {
      linkExistente.href = url;
      linkExistente.type = type;
    } else {
      const link = this.documento.createElement('link');
      link.rel = 'icon';
      link.type = type;
      link.href = url;
      this.documento.head.appendChild(link);
    }
  }
}
